/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MaintenanceScheduleStateEnum } from './maintenanceScheduleStateEnum';


export interface MaintenanceScheduleTenantGetResponseSpec { 
    state: MaintenanceScheduleStateEnum;
    /**
     * Maintenance schedule start time
     */
    start_datetime?: Date;
    /**
     * Maintenance schedule end time
     */
    end_datetime?: Date;
    /**
     * Maintenance schedule info update time
     */
    updated_timestamp: Date;
}
export namespace MaintenanceScheduleTenantGetResponseSpec {
}


